import "core-js/modules/web.timers";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import StartupInfoMixins from '../../mixins/startupInfoMixins';

var PollUpdateTipModal = function (_super) {
  __extends(PollUpdateTipModal, _super);

  function PollUpdateTipModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.timeoutStatus = false;
    _this.timer = null;
    return _this;
  }

  PollUpdateTipModal.prototype.onVisibleChange = function (value) {
    if (!value) {
      return;
    }

    this.pollingGetNewStatus();
  };

  PollUpdateTipModal.prototype.pollingGetNewStatus = function () {
    var _this = this;

    var count = 0;
    this.visible = true;
    this.timer = setInterval(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var data;

        var _a;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4, this.queryAccountCodeStartupInfo({
                account_code: (_a = this.data.sign_body_info) === null || _a === void 0 ? void 0 : _a.account_code
              })];

            case 1:
              data = _b.sent();

              if (data && data.sign_body_info && data.sign_body_info.sign_body_status !== this.$enum.mine.SignBodyStatusEnum.DRAFT && data.sign_body_info.sign_body_status !== this.$enum.mine.SignBodyStatusEnum.AUDIT_NOT_PASS && data.sign_body_info.sign_body_status !== this.$enum.mine.SignBodyStatusEnum.DISCARDED) {
                typeof this.onSuccess === 'function' && this.onSuccess();
                this.visible = false;
                this.clearTimer();
              }

              if (count >= 120) {
                this.timeoutStatus = true;
                this.clearTimer();
              }

              count++;
              return [2];
          }
        });
      });
    }, 5000);
  };

  PollUpdateTipModal.prototype.clearTimer = function () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  };

  PollUpdateTipModal.prototype.handleCertification = function () {
    var _this = this;

    this.visible = false;
    this.clearTimer();
    this.updateSubjectStatus(function (data) {
      typeof _this.onSuccess === 'function' && _this.onSuccess();
    });
  };

  __decorate([Prop({
    type: Function,
    "default": function _default() {
      return {};
    }
  })], PollUpdateTipModal.prototype, "onSuccess", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], PollUpdateTipModal.prototype, "isPool", void 0);

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return {};
    }
  })], PollUpdateTipModal.prototype, "data", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], PollUpdateTipModal.prototype, "onVisibleChange", null);

  PollUpdateTipModal = __decorate([Component], PollUpdateTipModal);
  return PollUpdateTipModal;
}(Mixins(StartupInfoMixins));

export default PollUpdateTipModal;